import {Checkbox as RacCheckbox, type CheckboxProps} from 'react-aria-components'

import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './Checkbox.module.scss'

interface Props {
  label: string | ReactNode
  labelClassName?: string
  isLabelVisible?: boolean
  onChange?: MemoizedCallbackOrDispatch<boolean>
}

export default memo(function Checkbox({
  label,
  labelClassName,
  isLabelVisible,
  ...props
}: Props & Omit<CheckboxProps, 'children' | 'onChange'>) {
  return (
    <RacCheckbox {...props} className={clsx(style.CheckboxContainer, props.className)}>
      {({isIndeterminate, isReadOnly}) => (
        <>
          <div className={clsx(style.Checkbox, isReadOnly && style.IsReadOnly)}>
            <svg viewBox='0 0 18 18' aria-hidden='true' className={style.CheckboxIcon}>
              {isIndeterminate ? (
                <rect x={1} y={7.5} width={15} height={3} />
              ) : (
                <polyline points='1 9 7 14 15 4' />
              )}
            </svg>
          </div>
          <VisuallyHidden as='span' className={labelClassName} isVisible={!!isLabelVisible}>
            {label}
          </VisuallyHidden>
        </>
      )}
    </RacCheckbox>
  )
})
